<template>
  <section >
    <h1> Design your own HSBC spoof advert</h1>

    <p> Simply type some words in to create your own HSBC advert. </p>

    <p>When you've finished, click  Create Image .</p>
    <p>
      Right click to download your image and then email your design to brandalism@riseup.net We'll print and install the best ones!
    </p>

    <div v-if="output">
      <div>
        <img class="poster-display" :src="output" />    
      </div>
      <v-btn large dark :href="output" download>Download</v-btn>
    </div>
    <v-container fluid class="portrait"> 
      <v-row>
        <v-col cols>
          <div class="poster-wrapper">
            <div class="poster-container" ref="printMe" id="capture" >
            
              <div class="topStrapLine1 strap">
                <div class="measure"><span class="red-text">{{topStrapLine1}} </span> </div>
              </div>
              <div class="topStrapLine2 strap"><div class="measure">{{topStrapLine2}}</div></div>
              <div class="topStrapLine3 strap"><div class="measure">{{topStrapLine3}}</div></div>
              <div class="topStrapLine4 strap"><div class="measure">{{topStrapLine4}}</div></div>
  
              <div class="centerStrapLine1 strap"><div class="measure">{{centerStrapLine1}}</div></div>
              <div class="centerStrapLine2 strap"><div class="measure">{{centerStrapLine2}}</div></div>
              <div class="centerStrap strap"><div class="measure">{{centerStrap}}</div></div>
              <div class="centerStrapLine3 strap"><div class="measure">{{centerStrapLine3}}</div></div>
              <div class="centerStrapLine4 strap"><div class="measure">{{centerStrapLine4}}</div></div>

              <div class="bottomStrapLine1 strap"><div class="measure">{{bottomStrapLine1}}</div></div>
              <div class="bottomStrapLine2 strap"><div class="measure">{{bottomStrapLine2}}</div></div>
              <div class="bottomStrapLine3 strap"><div class="measure">{{bottomStrapLine3}}</div></div>
              <div class="bottomStrapLine4 strap"><div class="measure">{{bottomStrapLine4}}</div></div>
          
            </div>
          </div>
        </v-col>
        <v-col>
          <!-- <v-text-field
            v-model="topStrapLine1RedSect"
            dense
            label="Red section top heading 1"
            v-on:keyup="fit('topStrapLine1')" 
            
          ></v-text-field> -->
          <v-text-field height="30" v-model="topStrapLine1" v-on:keyup="fit('topStrapLine1')" dense ></v-text-field>
          <v-text-field height="20" v-model="topStrapLine2" v-on:keyup="fit('topStrapLine2')" dense  ></v-text-field>
          <v-text-field v-model="topStrapLine3" v-on:keyup="fit('topStrapLine3')" dense  ></v-text-field>
          <v-text-field v-model="topStrapLine4" v-on:keyup="fit('topStrapLine4')" dense></v-text-field>

          <v-text-field v-model="centerStrapLine1" v-on:keyup="fit('centerStrapLine1')" dense ></v-text-field>
          <v-text-field v-model="centerStrapLine2" v-on:keyup="fit('centerStrapLine2')" dense ></v-text-field>
          <v-text-field v-model="centerStrap" v-on:keyup="fit('centerStrap')" dense ></v-text-field>
          <v-text-field v-model="centerStrapLine3" v-on:keyup="fit('centerStrapLine3')" dense ></v-text-field>
          <v-text-field v-model="centerStrapLine4" v-on:keyup="fit('centerStrapLine4')" dense ></v-text-field>
         

          <v-text-field
            v-model="bottomStrapLine1"
            v-on:keyup="fit('bottomStrapLine1')"
            dense
          ></v-text-field>
          <v-text-field v-model="bottomStrapLine2" dense v-on:keyup="fit('bottomStrapLine2')" ></v-text-field>
          <v-text-field
            v-model="bottomStrapLine3"
            v-on:keyup="fit('bottomStrapLine3')"
            dense
          ></v-text-field>
          <v-text-field
            v-model="bottomStrapLine4"
            v-on:keyup="fit('bottomStrapLine4')"
            dense
          ></v-text-field>

          <v-btn large dark @click="generate()">Create image</v-btn>
   
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PosterMain",

  data() {
    return {     
      output: null,
      topStrapLine1RedSect: "Red section",
      topStrapLine1: "Bold red statement",
      topStrapLine2: "List things people like",
      topStrapLine3: "football, sex,",
      topStrapLine4: "coffee, beer, food",
      
      centerStrapLine1: "television programmes.",
      centerStrapLine2: "Leveraging culture",
      centerStrap: "You are profitable",
      centerStrapLine3: "To sell our banking",
      centerStrapLine4: "service thats",
      
      bottomStrapLine1: "main object is",
      bottomStrapLine2: "the increase",
      bottomStrapLine3: "wealth of our",
      bottomStrapLine4: "share holders",
    };
  },
  methods: {
    async generate() {

      //document.querySelector('.poster-container').style.width = "3000px";
      
      const el = this.$refs.printMe;

      const options = {
        type: "dataURL",
        letterRendering: true,
      };
      this.output = await this.$html2canvas(el, options);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    fit(el){   
      var line = document.querySelector("." + el)
      line.style.letterSpacing = "inherit";
      var lineWidth = line.offsetWidth
      var textWidth = document.querySelector("." + el + " .measure").offsetWidth
      var letters = this[el].length - 1 ;
      // if (el === "topStrapLine1") {
      //   letters += this.topStrapLine1RedSect.length + 1
      // }
      var sizeDiff = (lineWidth - textWidth)
      var letterSpac = sizeDiff/letters

      line.style.letterSpacing = parseFloat(letterSpac).toFixed( 2 ) + "px";

    },
  },
  mounted() {
    var self = this
    setTimeout(function(){ 
      self.fit("topStrapLine1");
      self.fit("topStrapLine2");
      self.fit("topStrapLine3")
      self.fit("topStrapLine4")
      
      self.fit("centerStrapLine1");
      self.fit("centerStrapLine2");
      self.fit("centerStrap");
      self.fit("centerStrapLine3");
      self.fit("centerStrapLine4");

      self.fit("bottomStrapLine1");
      self.fit("bottomStrapLine2");
      self.fit("bottomStrapLine3");
      self.fit("bottomStrapLine4");
    }, 500);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >

@font-face {
  font-family: 'Graph';
  font-style: normal;
  font-weight: normal;
  src: local('Graph'), url('../assets/Graph-Bold.otf') format('truetype');
}

body {
  margin: 0;
  //font-family: 'Graph', serif;
  
  #app{
    margin-top: 0;
    color: #000;
  }
}

section {
  .poster-container {
    .measure {
      position: relative;
      display: inline;
      height: auto;
      width: auto;
      white-space: nowrap;
    }
    margin: auto;
    text-align: left;
    word-wrap: normal;
    position: relative;
    overflow: hidden;

    background-image: url("../assets/HSBC-Hexagon-symbol.png");
    background-size: 100px 200px;
    background-position: center center;
    background-repeat: no-repeat;

    font-size: 50px;
    font-family: "Open Sans Condensed", sans-serif;
    .red-text {
      color: #DB0011;
    }
    .strap {
   
      position: absolute;
      text-transform: uppercase;
      overflow: hidden;
    }
  }

  .portrait .poster-container {

    width: 450px;
    height: 664px;
    border:black 1px solid;
    background-image: url("../assets/HSBC-Hexagon-symbol.png");
    background-size: auto 215px;
    background-position: center center;
    background-repeat: no-repeat;

    font-size: 35px;
    font-family: "Graph", "Open Sans Condensed", sans-serif;
    .poster-display {
      width: 1000px;
      height: auto;
    }
 
    .strap {
      width: 370px;
      margin-left: 36px;
      line-height: 40px;
      position: absolute;
      text-transform: uppercase;
      overflow: hidden;
    }
    .topStrapLine1 {
      top: 32px;
      height: 55px;
    }
    .topStrapLine2 {
      top: 70px;
      height: 55px;
    }
    .topStrapLine3 {
      top: 108px;
      height: 55px;
    }
    .topStrapLine4 {
      top: 146px;
      height: 55px;
    }
    .centerStrapLine1 {
      top: 184px;
      height: 55px;
    }
    .centerStrapLine2 {
      top: 222px;
      height: 55px;
    }
    
    .centerStrap {
      margin-left: 20px;
      font-size: 55px;
      height: 55px;
      line-height: 55px;
      width: 415px;
      top: 304px;
    }

    .centerStrapLine3 {
      top: 396px;
      height: 55px;
    }
    .centerStrapLine4 {
      top: 438px;
      height: 55px;
    }
 
    .bottomStrapLine1 {
      height: 55px;
      top: 472px;
    }
    .bottomStrapLine2 {
      height: 55px;
      top: 510px;
    }
    .bottomStrapLine3 {
      height: 55px;
      top: 548px;
    }
    .bottomStrapLine4 {
      height: 55px;
      top: 586px;
    }
  }




  .landscape .poster-container {
    .measure {
      position: relative;
      display: inline;
      height: auto;
      width: auto;
      white-space: nowrap;
    }
    text-align: left;
    word-wrap: normal;
    position: relative;
    overflow: hidden;
    width: 1200px;
    height: 594px;

    background-image: url("../assets/HSBC-Hexagon-symbol.png");
    background-size: 600px 600px;
    background-position: center center;
    background-repeat: no-repeat;

    font-size: 50px;
    font-family: "Open Sans Condensed", sans-serif;
    .red-text {
      color: #DB0011;
    }
    .strap {
      width: 1100px;
      margin-left: 50px;
      line-height: 50px;
      position: absolute;
      text-transform: uppercase;
      overflow: hidden;
    }
    .topStrapLine1 {
      top: 50px;
      height: 55px;
    }
    .topStrapLine2 {
      top: 100px;
      height: 55px;
    }
    .topStrapLine3 {
      top: 150px;
      height: 55px;
    }
    .centerStrap {
      font-size: 140px;
      line-height: 150px;
      height: 170px;
      top: 200px;
    }
    .bottomStrapLine1 {
      height: 55px;
      bottom: 190px;
    }
    .bottomStrapLine2 {
      height: 55px;
      bottom: 140px;
    }
    .bottomStrapLine3 {
      height: 55px;
      bottom: 90px;
    }
  }

  .poster-display {
    width: 450px;
    height: auto;
  }
}
</style>
